module.exports = __webpack_public_path__ + "static/media/1yr-au-cny.bfb8b6d9.png";